import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import FamilyService from "../services/family.service";
import UserService from "../services/user.service";
import ProfileModals from "./profile-modals.component";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: null,
      userReady: false,
      currentUser: { username: "" },
      familyMembers: {},
      showAddMemberModal: false,
      showDeleteMemberModal: false,
      showAddFamilyModal: false,
      showEditFamilyNameModal: false,
      showDeleteFamilyModal: false,
      familyToDelete: null,
      selectedFamilyId: null,
      emailToAdd: "",
      memberToDelete: null,
      newFamilyName: "",
      message: "",
      showEditUserModal: false,
      editedUser: {
        username: "",
        email: "",
      },
    };

    this.handleAddMember = this.handleAddMember.bind(this);
    this.handleDeleteMember = this.handleDeleteMember.bind(this);
    this.handleEditFamilyName = this.handleEditFamilyName.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleShowAddMemberModal = this.handleShowAddMemberModal.bind(this);
    this.handleShowDeleteMemberModal =this.handleShowDeleteMemberModal.bind(this);
    this.handleShowAddFamilyModal = this.handleShowAddFamilyModal.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleMemberToDeleteChange =
      this.handleMemberToDeleteChange.bind(this);
    this.submitAddMember = this.submitAddMember.bind(this);
    this.submitAddFamily = this.submitAddFamily.bind(this);
    this.submitDeleteFamily = this.submitDeleteFamily.bind(this);
    this.submitEditFamilyName = this.submitEditFamilyName.bind(this);
    this.submitDeleteMember = this.submitDeleteMember.bind(this);
    this.handleShowEditUserModal = this.handleShowEditUserModal.bind(this);
    this.handleCloseEditUserModal = this.handleCloseEditUserModal.bind(this);
    this.handleUserInputChange = this.handleUserInputChange.bind(this);
    this.submitEditUser = this.submitEditUser.bind(this);
    this.handleNewFamilyNameChange = this.handleNewFamilyNameChange.bind(this);
  }

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();

    if (!currentUser) {
      this.setState({ redirect: "/home" });
    } else {
      this.setState({ currentUser: currentUser, userReady: true });
      if (currentUser.families) {
        currentUser.families.forEach((family) => {
          FamilyService.getFamilyMembers(family.id).then((response) => {
            this.setState((prevState) => ({
              familyMembers: {
                ...prevState.familyMembers,
                [family.id]: response.data,
              },
            }));
          });
        });
      }
    }
  }

  handleCloseModal() {
    this.setState({
      showAddMemberModal: false,
      showDeleteMemberModal: false,
      showAddFamilyModal: false,
      showEditFamilyNameModal: false,
      showDeleteFamilyModal: false,
      familyToDelete: null,
      selectedFamilyId: null,
      emailToAdd: "",
      memberToDelete: null,
      newFamilyName: "",
      message: "",
      showEditUserModal: false,
    });
  }

  handleShowAddMemberModal(familyId) {
    this.setState({ showAddMemberModal: true, selectedFamilyId: familyId });
  }

  handleShowDeleteMemberModal(familyId) {
    this.setState({ showDeleteMemberModal: true, selectedFamilyId: familyId });
  }

  handleEditFamilyNameModal(familyId) {
    this.setState({
      showEditFamilyNameModal: true,
      selectedFamilyId: familyId,
    });
  }

  handleShowAddFamilyModal() {
    this.setState({ showAddFamilyModal: true, message: "" });
  }

  handleShowEditUserModal() {
    const { currentUser } = this.state;
    this.setState({
      showEditUserModal: true,
      editedUser: {
        username: currentUser.username,
        email: currentUser.email,
      },
      message: "",
    });
  }

  handleCloseEditUserModal() {
    this.setState({ showEditUserModal: false });
  }

  handleEmailChange(e) {
    this.setState({ emailToAdd: e.target.value });
  }

  handleNewFamilyNameChange(e) {
    this.setState({ newFamilyName: e.target.value });
  }

  handleUserInputChange(e) {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      editedUser: {
        ...prevState.editedUser,
        [name]: value,
      },
    }));
  }

  handleMemberToDeleteChange(e) {
    this.setState({ memberToDelete: e.target.value });
  }

  submitAddMember() {
    FamilyService.addUserWithEmailToFamily(
      this.state.selectedFamilyId,
      this.state.emailToAdd
    )
      .then((response) => {
        this.setState({ message: response.data.message });
        // Refresh family members
        FamilyService.getFamilyMembers(this.state.selectedFamilyId).then(
          (response) => {
            this.setState((prevState) => ({
              familyMembers: {
                ...prevState.familyMembers,
                [this.state.selectedFamilyId]: response.data,
              },
            }));
          }
        );
      })
      .catch((e) => {
        this.setState({ message: e.response.data.message });
      });
  }

  submitAddFamily() {
    FamilyService.create({ name: this.state.newFamilyName })
      .then((familyResponse) => {
        const newFamily = familyResponse.data;
        // print newFamily to console
        console.log("New Family Created:", newFamily);
        const currentUser = AuthService.getCurrentUser();
        // Add the creator to the new family
        return FamilyService.addUserWithEmailToFamily(
          newFamily._id,
          currentUser.email
        ).then(() => newFamily);
      })
      .then((newFamily) => {
        // NOTE: The backend does not update the user's family list.
        // We manually update the state to show the new family immediately.
        // This change will be lost on re-login.
        const updatedCurrentUser = { ...this.state.currentUser };
        updatedCurrentUser.families.push({
          id: newFamily._id,
          name: newFamily.name,
        });
        this.setState({
          currentUser: updatedCurrentUser,
          message: "Family created successfully!",
        });

        // Fetch members for the newly created family
        return FamilyService.getFamilyMembers(newFamily._id).then(
          (membersResponse) => {
            this.setState((prevState) => ({
              familyMembers: {
                ...prevState.familyMembers,
                [newFamily._id]: membersResponse.data,
              },
            }));
          }
        );
      })
      .then(() => {
        this.handleCloseModal();
      })
      .catch((e) => {
        this.setState({
          message:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "An error occurred while creating the family.",
        });
      });
  }

  submitEditUser() {
    const { currentUser, editedUser } = this.state;
    UserService.editUser(currentUser.id, editedUser)
      .then(() => {
        const updatedCurrentUser = { ...currentUser, ...editedUser };
        localStorage.setItem("user", JSON.stringify(updatedCurrentUser));
        this.setState({
          currentUser: updatedCurrentUser,
          message: "User updated successfully!",
          showEditUserModal: false,
        });
      })
      .catch((e) => {
        this.setState({
          message:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "An error occurred while updating the user.",
        });
      });
  }

  submitDeleteFamily() {
    FamilyService.delete(this.state.familyToDelete)
      .then(() => {
        const updatedCurrentUser = { ...this.state.currentUser };
        updatedCurrentUser.families = updatedCurrentUser.families.filter(
          (f) => f.id !== this.state.familyToDelete
        );
        this.setState({
          currentUser: updatedCurrentUser,
          message: "Family deleted successfully!",
        });
        this.handleCloseModal();
      })
      .catch((e) => {
        this.setState({
          message:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "An error occurred while deleting the family.",
        });
      });
  }

  submitEditFamilyName() {
    FamilyService.update(this.state.selectedFamilyId, {
      name: this.state.newFamilyName,
    })
      .then((response) => {
        this.setState({ message: "Family name updated successfully!" });
        // Manually update the family name in the current user's state
        const updatedCurrentUser = { ...this.state.currentUser };
        const familyIndex = updatedCurrentUser.families.findIndex(
          (f) => f.id === this.state.selectedFamilyId
        );
        if (familyIndex > -1) {
          updatedCurrentUser.families[familyIndex].name =
            this.state.newFamilyName;
        }
        this.setState({ currentUser: updatedCurrentUser });
        this.handleCloseModal();
      })
      .catch((e) => {
        this.setState({
          message:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "An error occurred while updating the family name.",
        });
      });
  }

  submitDeleteMember() {
    const { selectedFamilyId, memberToDelete, familyMembers } = this.state;
    const members = familyMembers[selectedFamilyId];

    if (members.length === 1) {
      FamilyService.delete(selectedFamilyId)
        .then((response) => {
          this.setState({ message: response.data.message });
          // Refresh the user data to update the families list
          const currentUser = AuthService.getCurrentUser();
          this.setState({ currentUser: currentUser });
          this.handleCloseModal();
        })
        .catch((e) => {
          this.setState({ message: e.response.data.message });
        });
    } else {
      FamilyService.removeUserFromFamily(selectedFamilyId, memberToDelete)
        .then((response) => {
          this.setState({ message: response.data.message });
          // Refresh family members
          FamilyService.getFamilyMembers(selectedFamilyId).then((response) => {
            this.setState((prevState) => ({
              familyMembers: {
                ...prevState.familyMembers,
                [selectedFamilyId]: response.data,
              },
            }));
          });
        })
        .catch((e) => {
          this.setState({ message: e.response.data.message });
        });
    }
  }

  handleAddMember(familyId) {
    this.handleShowAddMemberModal(familyId);
  }

  handleDeleteMember(familyId) {
    this.handleShowDeleteMemberModal(familyId);
  }
  handleEditFamilyName(familyId) {
    this.handleEditFamilyNameModal(familyId);
  }

  handleDeleteFamily(familyId) {
    this.setState({
      showDeleteFamilyModal: true,
      familyToDelete: familyId,
      message: "",
    });
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />;
    }

    const {
      currentUser,
      familyMembers,
      showAddMemberModal,
      showDeleteMemberModal,
      showEditFamilyNameModal,
      showAddFamilyModal,
      showDeleteFamilyModal,
      selectedFamilyId,
      emailToAdd,
      message,
      showEditUserModal,
      editedUser,
    } = this.state;

    const membersOfSelectedFamily = selectedFamilyId
      ? familyMembers[selectedFamilyId]
      : [];

    return (
      <div className="container">
        {this.state.userReady ? (
          <div>
            <header className="jumbotron">
              <h3>
                <strong>{currentUser.username}</strong> Profile
              </h3>
            </header>
            <p>
              <strong>Token:</strong>{" "}
              {currentUser.accessToken.substring(0, 20)} ...{" "}
              {currentUser.accessToken.substr(
                currentUser.accessToken.length - 20
              )}
            </p>
            <p>
              <strong>Id:</strong> {currentUser.id}
            </p>
            <p>
              <strong>Email:</strong> {currentUser.email}
            </p>
            <strong>Authorities:</strong>
            <ul>
              {currentUser.roles &&
                currentUser.roles.map((role, index) => (
                  <li key={index}>{role}</li>
                ))}
            </ul>
            <div className="mt-3">
              <button
                className="btn btn-primary"
                onClick={this.handleShowEditUserModal}
              >
                Edit User
              </button>
            </div>
            <strong>Families:</strong>
            <div className="my-3">
              <button
                className="btn btn-success me-3"
                onClick={this.handleShowAddFamilyModal}
              >
                Add Family
              </button>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Family Name</th>
                  <th>Members</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentUser.families &&
                  currentUser.families.map((family) => (
                    <tr key={family.id}>
                      <td>{family.name}</td>
                      <td>
                        {familyMembers[family.id]
                          ? familyMembers[family.id]
                              .map((member) => member.username)
                              .join(", ")
                          : "Loading..."}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => this.handleAddMember(family.id)}
                        >
                          👤➕
                        </button>
                        <button
                          className="btn btn-sm btn-danger ms-2"
                          onClick={() => this.handleDeleteMember(family.id)}
                        >
                          👤➖
                        </button>
                        <button
                          className="btn btn-sm btn-primary ms-2"
                          onClick={() => this.handleEditFamilyName(family.id)}
                        >
                          ✏️
                        </button>
                        <button
                          className="btn btn-sm btn-danger ms-2"
                          onClick={() => this.handleDeleteFamily(family.id)}
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ) : null}

        <ProfileModals
          showAddFamilyModal={showAddFamilyModal}
          handleCloseModal={this.handleCloseModal}
          message={message}
          newFamilyName={this.state.newFamilyName}
          handleNewFamilyNameChange={this.handleNewFamilyNameChange}
          submitAddFamily={this.submitAddFamily}
          showDeleteFamilyModal={showDeleteFamilyModal}
          submitDeleteFamily={this.submitDeleteFamily}
          showAddMemberModal={showAddMemberModal}
          emailToAdd={emailToAdd}
          handleEmailChange={this.handleEmailChange}
          submitAddMember={this.submitAddMember}
          showDeleteMemberModal={showDeleteMemberModal}
          membersOfSelectedFamily={membersOfSelectedFamily}
          handleMemberToDeleteChange={this.handleMemberToDeleteChange}
          submitDeleteMember={this.submitDeleteMember}
          showEditFamilyNameModal={showEditFamilyNameModal}
          submitEditFamilyName={this.submitEditFamilyName}
          showEditUserModal={showEditUserModal}
          handleCloseEditUserModal={this.handleCloseEditUserModal}
          editedUser={editedUser}
          handleUserInputChange={this.handleUserInputChange}
          submitEditUser={this.submitEditUser}
        />
      </div>
    );
  }
}
